import { useNavigate } from "react-router-dom";
//Props Validations
import PropTypes from "prop-types";

// import mui components
import TextAnalysisIcon from "../../assets/icon-for-text-theam.png";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import AutoGraphRoundedIcon from "@mui/icons-material/AutoGraphRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import JoinLeftRoundedIcon from "@mui/icons-material/JoinLeftRounded";
import GradingRoundedIcon from "@mui/icons-material/GradingRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import FragranceDriverIcon from "../../assets/icons/FrafranceDriverIcon.png";
import CircularProgress from "@mui/material/CircularProgress";

import TextThemePopup from "./TextThemePopup";
import { consumerFilterPayload } from "utils/consumerFilterUtils";

import { useSelector } from "react-redux";

function MainNavigation({ buttons = [], btnDisabledObj = {}, navigationLoader = false, isFragrance = false, textThemeNavState }) {
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const consumerFilter = useSelector((state) => state.consumerFilterStore.currentSelectedFilters);
    const productSelections = useSelector((state) => state.textThemeStore.selections);

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isCorrelationLongLabel = isSkinCare || isHairCare;
    const disabledColor = "#D8D8D8";
    const navigate = useNavigate();

    const buttonStyles = () => {
        if (isCorrelationLongLabel) {
            if (buttons.length === 6) {
                return `
          .buttons:hover .button-position-5 {
            translate: 165px -5px;
          }
          .buttons:hover .button-position-4 {
            translate: 105px -52px;
          }
          .buttons:hover .button-position-3 {
            translate: 35px -78px;
          }
          .buttons:hover .button-position-2 {
            translate: -35px -78px;
          }
          .buttons:hover .button-position-1 {
           translate: -105px -52px;
          }
          .buttons:hover .button-position-0 {
            translate: -165px -5px;
          }
         `;
            }
            if (buttons.length === 5) {
                return `
                .buttons:hover .button-position-4 {
                    translate: 190px 0px;
                }

                .buttons:hover .button-position-3 {
                    translate: 100px -45px;
                }

                .buttons:hover .button-position-2 {
                    translate: 0px -70px;
                }

                .buttons:hover .button-position-1 {
                    translate: -100px -45px;
                }

                .buttons:hover .button-position-0 {
                    translate: -190px 0px;
                }
            `;
            } else if (buttons.length === 4) {
                return `
                .buttons:hover .button-position-3 {
                    translate: 140px -20px;
                }

                .buttons:hover .button-position-2 {
                    translate: 50px -65px;
                }

                .buttons:hover .button-position-1 {
                    translate: -50px -65px
                }

                .buttons:hover .button-position-0 {
                    translate: -140px -20px;
                }
            `;
            } else {
                return `
                .buttons:hover .button-position-2 {
                    translate: 80px -30px;
                }

                .buttons:hover .button-position-1 {
                    translate: 0px -60px;
                }

                .buttons:hover .button-position-0 {
                    translate: -80px -30px
                }
            `;
            }
        }

        if (buttons.length === 5) {
            return `
                .buttons:hover .button-position-4 {
                    translate: 110px 0px;
                }
                
                .buttons:hover .button-position-3 {
                    translate: 60px -50px;
                }

                .buttons:hover .button-position-2 {
                    translate: 0px -80px;
                }

                .buttons:hover .button-position-1 {
                    translate: -60px -50px;                      
                }

                .buttons:hover .button-position-0 {
                    translate: -110px 0px;
                }
            `;
        } else if (buttons.length === 4) {
            return `
                .buttons:hover .button-position-3 {
                    translate: 80px -25px;
                }

                .buttons:hover .button-position-2 {
                    translate: 30px -70px;
                }

                .buttons:hover .button-position-1 {
                    translate: -30px -70px                       
                }

                .buttons:hover .button-position-0 {
                    translate: -80px -25px;
                }
            `;
        } else {
            return `
                .buttons:hover .button-position-2 {
                    translate: 70px -30px;
                }

                .buttons:hover .button-position-1 {
                    translate: 0px -65px;
                }

                .buttons:hover .button-position-0 {
                    translate: -70px -30px                       
                }
            `;
        }
    };
    const buttonStylesFragrance = () => {
        if (buttons.length === 5) {
            return `
                .buttons:hover .button-position-4 {
                    translate: 160px 0px;
                }
                
                .buttons:hover .button-position-3 {
                    translate: 100px -50px;
                }

                .buttons:hover .button-position-2 {
                    translate: 0px -80px;
                }

                .buttons:hover .button-position-1 {
                    translate: -80px -50px;                      
                }

                .buttons:hover .button-position-0 {
                    translate: -160px 0px;
                }
            `;
        } else {
            return `
                .buttons:hover .button-position-3 {
                    translate: 130px -10px;
                }

                .buttons:hover .button-position-2 {
                    translate: 65px -60px;
                }

                .buttons:hover .button-position-1 {
                    translate: -65px -60px                       
                }

                .buttons:hover .button-position-0 {
                    translate: -130px -10px;
                }
            `;
        }
    };

    const buttonStylesUnileverFragranceHouse = () => {
        const defaultTitle = selectedStudies.length > 0 ? selectedStudies[0].study_type_method__default_title?.replace(/\s+/g, "")?.toLowerCase() : "";
        if (defaultTitle === "clt") {
            if (buttons.length === 2) {
                return `
                    .buttons:hover .button-position-1 {
                        translate: 60px -50px;
                    }

                    .buttons:hover .button-position-0 {
                        translate: -75px -50px           
                    }
                `;
            } else {
                return `
                    .buttons:hover .button-position-2 {
                        translate: 80px -40px;
                    }

                    .buttons:hover .button-position-1 {
                        translate: 0px -75px;
                    }

                    .buttons:hover .button-position-0 {
                        translate: -90px -40px           
                    }
                `;
            }
        } else {
            if (buttons.length === 3) {
                return `
                    .buttons:hover .button-position-2 {
                        translate: 70px -30px;
                    }

                    .buttons:hover .button-position-1 {
                        translate: 0px -65px;
                    }

                    .buttons:hover .button-position-0 {
                        translate: -70px -30px                       
                    }
                `;
            } else {
                return `
                .buttons:hover .button-position-3 {
                    translate: 80px -25px;
                }

                .buttons:hover .button-position-2 {
                    translate: 30px -70px;
                }

                .buttons:hover .button-position-1 {
                    translate: -30px -70px                       
                }

                .buttons:hover .button-position-0 {
                    translate: -80px -25px;
                }
            `;
            }
        }
    };

    const navigationAvailability = useSelector((state) => state.studyDataStore.navigationAvailability);
    const selectedStudies = useSelector((state) => state.studyDataStore.selectedStudies);
    const studyTypeMethod = selectedStudies[0]?.study_type_method__default_title.toUpperCase().split(" ").join("_") || "DEFAULT";
    const FRAGRANCE_METRICS_MAP = {
        DEFAULT: "fragranceMetricsAnalysis",
        CLT: "fragranceMetricsAnalysisCLT",
        EXPRESSCLT: "fragranceMetricsAnalysisExpressCLT",
        CONCEPT_TESTING: "fragranceMetricsAnalysisExpressCLT",
    };

    const PRODUCT_PREFERENCE_MAP = {
        DEFAULT: "productPreferenceAnalysis",
        EXPRESSCLT: "productPreferenceAnalysisExpressCLT",
        CONCEPT_TESTING: "productPreferenceAnalysisExpressCLT",
    };

    const AGREEMENT_KPI_MAP = {
        DEFAULT: "agreementKpi",
        CLT: "agreementkpiClt",
    };

    const fragranceMetricsKey = FRAGRANCE_METRICS_MAP[studyTypeMethod] ?? FRAGRANCE_METRICS_MAP.DEFAULT;
    const productPreferenceKey = PRODUCT_PREFERENCE_MAP[studyTypeMethod] ?? PRODUCT_PREFERENCE_MAP.DEFAULT;
    const agreementKpiKey = AGREEMENT_KPI_MAP[studyTypeMethod] ?? AGREEMENT_KPI_MAP.DEFAULT;

    let btnDisabledByData;
    if (isUnileverFragranceHouse) {
        const defaultTitle = selectedStudies[0]?.study_type_method__default_title?.replace(/\s+/g, "")?.toLowerCase();
        btnDisabledByData =
            defaultTitle === "clt"
                ? {
                      fragranceMetricsAnalysisCLT: navigationAvailability?.fragrance_metrics,
                      fragranceAssociationCLT: navigationAvailability?.fragrance_association,
                      agreementkpiClt: navigationAvailability?.agreement,
                  }
                : {
                      overallKpi: navigationAvailability?.overall || navigationAvailability?.secondary,
                      agreementKpi: navigationAvailability?.agreement,
                      justRight: navigationAvailability?.jar,
                      correlation: navigationAvailability?.correlation,
                  };
    } else {
        btnDisabledByData = isFragrance
            ? {
                [fragranceMetricsKey]: navigationAvailability?.fragrance_metrics,
                preferenceAnalysis: navigationAvailability?.preference,
                fragranceAssociationCLT: navigationAvailability?.fragrance_association,
                [agreementKpiKey]: navigationAvailability?.agreement,
                [productPreferenceKey]: navigationAvailability?.product_preference,
            }
            : {
                overallKpi: navigationAvailability?.overall || navigationAvailability?.secondary,
                agreementKpi: navigationAvailability?.agreement,
                claims: navigationAvailability?.claims,
                fragranceDriver: navigationAvailability?.fragrance_driver,
            correlation: navigationAvailability?.correlation,
                justRight: isHairCare || isSkinCare ? navigationAvailability?.jar : navigationAvailability?.just_right,
                textAnalysis: navigationAvailability?.has_open_ended_variables,
            };
    }

    const navigateTo = (route, buttonKey) => {
        if (buttonKey === "textAnalysis" && textThemeNavState) {
            // Placeholder for consumer filter logic if needed

            let tempCFArr = []
            productSelections.forEach((ele) => {
                const filterObj = consumerFilterPayload(consumerFilter, ele.productCodeTitle, ele.coreDataId);
                if (Object.keys(filterObj).length > 0) {
                    tempCFArr.push(filterObj);
                }
            });
            if (tempCFArr.length > 0) {
                TextThemePopup.general(navigate, textThemeNavState);
            } else {
                navigate(route, { state: textThemeNavState });
            }
        } else {
            navigate(route);
        }
    };

    const buttonDetails = {
        overallKpi: {
            icon: <TimelineRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/overall-analysis/:page",
            label: "Overall",
        },
        agreementKpi: {
            icon: <AssignmentRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/agreement-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Agreement KPI </span>,
        },
        justRight: {
            icon: <TaskAltIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/just-right-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Just Right</span>,
        },
        claims: {
            icon: <GradingRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/claims-analysis",
            label: "Claims",
        },
        fragranceDriver: {
            icon: (
                <Box
                    sx={{
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img
                        src={FragranceDriverIcon}
                        alt="Fragrance Driver"
                        style={{
                            width: "33px",
                            height: "22px",
                        }}
                    />
                </Box>
            ),
            route: "/fragrance-driver",
            label: <span style={{ whiteSpace: "nowrap" }}>Fragrance Driver</span>,
        },
        correlation: {
            icon: <JoinLeftRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/correlation",
            label: (isHairCare || isSkinCare) ? <span style={{ whiteSpace: "nowrap" }}>Correlation & Driver Analysis</span> : "Correlation",
        },
        textAnalysis: {
            icon: (
                <Box
                    sx={{
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        src={TextAnalysisIcon}
                        alt="Text Theme Analysis Icon"
                        style={{
                            width: '20px',
                            height: '20px',
                        }}
                    />
                </Box>
            ),
            route: "/text-theme-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Text Analysis</span>,
        },
        fragranceMetricsAnalysis: {
            icon: <TimelineRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/fragrance-metrics-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Fragrance Metrics Analysis</span>,
        },
        fragranceMetricsAnalysisCLT: {
            icon: <TimelineRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/fragrance-metrics-analysis/clt/:page",
            label: <span style={{ whiteSpace: "nowrap" }}>Fragrance Metrics Analysis</span>,
        },
        fragranceMetricsAnalysisExpressCLT: {
            icon: <TimelineRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/fragrance-metrics-analysis/express-clt/:page",
            label: <span style={{ whiteSpace: "nowrap" }}>Fragrance Metrics Analysis</span>,
        },
        preferenceAnalysis: {
            icon: <TaskAltIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/preference-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Preference Analysis</span>,
        },
        fragranceAssociation: {
            icon: <GradingRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/claims-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Fragrance Association</span>,
        },
        agreementkpiClt: {
            icon: <AssignmentRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/agreement-analysis/clt",
            label: <span style={{ whiteSpace: "nowrap" }}>Agreement KPI </span>,
        },
        productPreferenceAnalysis: {
            icon: <JoinLeftRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/product-preference-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Product Preference Analysis</span>,
        },
        productPreferenceAnalysisExpressCLT: {
            icon: <JoinLeftRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/product-preference-analysis",
            label: <span style={{ whiteSpace: "nowrap" }}>Product Preference Analysis</span>,
        },
        fragranceAssociationCLT: {
            icon: <GradingRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/fragrance-association/clt",
            label: <span style={{ whiteSpace: "nowrap" }}>Fragrance Association</span>,
        },
    };

    const getButtonDetails = (btn, type) => {
        let btnInfo = buttonDetails[btn] || buttonDetails.correlation;

        // If it's the justRight button and we should show JAR Analysis
        if (btn === "justRight" && (isHairCare || isSkinCare || isUnileverFragranceHouse)) {
            btnInfo = {
                ...btnInfo,
                label: <span style={{ whiteSpace: "nowrap" }}>JAR</span>,
            };
        }

        return btnInfo[type];
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
            }}
        >
            <style>
                {`
                    .buttons {
                        position: absolute;
                        display: grid;
                        place-items: center;
                        height: fit-content;
                        width: fit-content;
                        transition: 0.3s;
                        top: 5px;
                       
                    }

                    .button span {
                        display: none;
                    }

                    .buttons:hover .button span {
                        display: block;
                    }
 
                    .main-button {
                        position: relative;
                        display: grid;
                        place-items: center;
                        padding: 10px 10px;
                        border: none;
                        background: transparent;
                        transition: 0.2s;
                    }
 
                    .button {
                        background: transparent;
                        position: absolute;
                        display: grid;
                        place-items: center;
                        padding: 10px;
                        border: none;
                        box-shadow: 5px 5px 12px rgba(202, 202, 202, 0), -5px -5px 12px rgba(255, 255, 255, 0);
                        transition: 0.5s;
                        border-radius: 10px;
                    }
                   
                    .button:hover{
                        transform:scale(1.2);
                    }
                    
                    .buttons:hover .button {
                        transition-delay: 0s;
                    }
                    .buttons:not(:hover) .button {
                        transition-delay: 0.5s;
                    }
 
                    .buttons:hover .correlation-button {
                        translate: 80px -25px;
                    }
 
                    .buttons:hover .claims-button {
                        translate: 30px -70px;
                    }
 
                    .buttons:hover .agreement-button {
                        translate: -30px -70px                       
                    }
 
                    .buttons:hover .overall-button {
                        translate: -80px -25px;
                    }
 
                `}
            </style>
            <style>{isUnileverFragranceHouse? buttonStylesUnileverFragranceHouse() : isFragrance ? buttonStylesFragrance() : buttonStyles()}</style>
            <div
                style={{
                    zIndex: 2,
                }}
            >
                <svg
                    width="162"
                    height="52"
                    viewBox="0 0 152 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient
                            id="gradient"
                            x1="0%"
                            y1="0%"
                            x2="100%"
                            y2="0%"
                        >
                            <stop
                                offset="0%"
                                style={{
                                    stopColor: "rgba(71, 163, 255, 1)",
                                    stopOpacity: 1,
                                }}
                            />
                            <stop
                                offset="100%"
                                style={{
                                    stopColor: "rgba(0, 94, 239, 1)",
                                    stopOpacity: 1,
                                }}
                            />
                        </linearGradient>
                    </defs>
                    <path
                        d="M0 41.0513C7.62 39.6013 15 37.6613 22.1 34.6813C31.01 30.9413 38.63 25.4313 45.1 18.2913C47.73 15.3913 50.36 12.4913 53.06 9.66128C58.66 3.81128 65.59 0.611281 73.63 0.081281C83.13 -0.548719 91.42 2.48128 98.19 9.25128C101.28 12.3413 104.18 15.6213 107.12 18.8613C116.51 29.1813 128.31 35.3313 141.66 38.7713C144.96 39.6213 148.28 40.3513 151.25 41.0613C101.12 41.0513 50.62 41.0513 0 41.0513Z"
                        fill="url(#gradient)"
                    />
                </svg>
            </div>
            <div className="buttons">
                <button className="main-button">
                    <AutoGraphRoundedIcon
                        sx={{
                            color: "#fff",
                            zIndex: 2,
                            position: "relative", // Make sure the icon is on top of the background
                        }}
                    />
                </button>

                {buttons.map((btn, index) => {
                    const btnClass = `button-position-${index} button`;
                    const btnIcon = getButtonDetails(btn, "icon");
                    const btnLabel = getButtonDetails(btn, "label");
                    const btnRoute = getButtonDetails(btn, "route");

                    return (
                        <button
                            key={btnClass}
                            className={btnClass}
                            style={{
                                transitionProperty: "translate",
                            }}
                            onClick={() => navigateTo(btnRoute, btn)}
                            disabled={btnDisabledObj[btn] || !btnDisabledByData[btn]}
                            title={!btnDisabledByData[btn] ? "No data present" : ""}
                        >
                            {navigationLoader ? (
                                <CircularProgress size={24} />
                            ) : (
                                <>
                                    <IconButton
                                        style={{
                                            background: btnDisabledObj[btn] || !btnDisabledByData[btn] ? disabledColor : undefined,
                                            boxShadow: "5px 5px 12px rgba(202, 202, 202, 0), -5px -5px 12px rgba(255, 255, 255, 0)",
                                            padding: "3px",
                                        }}
                                        className={btnDisabledObj[btn] || !btnDisabledByData[btn] ? undefined : "liner-light-blue-background"}
                                        size="small"
                                    >
                                        {btnIcon}
                                    </IconButton>

                                    <span
                                        style={{
                                            fontSize: "9px",
                                        }}
                                    >
                                        {btnLabel}
                                    </span>
                                </>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

// Typechecking props for the Study
MainNavigation.propTypes = {
    buttons: PropTypes.array,
    btnDisabledObj: PropTypes.object,
    navigationLoader: PropTypes.bool,
    isFragrance: PropTypes.bool,
    textThemeNavState: PropTypes.object,
};

export default MainNavigation;
